import { motion } from 'framer-motion';
import type { ChatMessage } from '@pullman/shared';
import { useReducedMotion } from '@/hooks/useReducedMotion';

interface UserBubbleProps {
  message: ChatMessage;
}

export function UserBubble({ message }: UserBubbleProps) {
  const reduced = useReducedMotion();
  const time = new Date(message.timestamp).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <motion.div
      className="flex justify-end px-4 md:px-0"
      initial={reduced ? undefined : { opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
    >
      <div className="max-w-[70%] md:max-w-[70%] sm:max-w-[85%]">
        <div
          className="bg-brand-navy text-white rounded-tl-bubble rounded-bl-bubble rounded-br-bubble rounded-tr-[4px] px-5 py-3"
        >
          <p className="text-[15px] leading-relaxed whitespace-pre-wrap">{message.content}</p>
        </div>
        <p className="text-right text-xs text-brand-charcoal/40 mt-1 mr-1">{time}</p>
      </div>
    </motion.div>
  );
}
